import Pagination from "./Pagination";
import moment from "moment";
import { useSelector, useDispatch } from 'react-redux'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import icon_filter from "../../assets/images/icon_filter.svg";
import icon_order_arrow_down from "../../assets/images/icon_order_arrow_down.svg";
import icon_alert from "../../assets/images/icon_alert.svg";
import icon_arrow_left from "../../assets/images/icon_arrow_left.svg";
import { ContextState } from "../../layout";
import { Tooltip } from "antd";
import React, { useContext, useEffect, useState } from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import { salesPaymentPending ,certsalesPaymentPending } from '../../api/reports'
import { salesPaymentPendingData } from '../../redux/report/action'
import { useLocation } from 'react-router-dom';

const CustomTable = ({ popContent, category, tag, postTable, tabName, search, flag, setFlag, filteredPosts, tableData, columns, loading, className, dragUpdater, courseKey, setDataSet, courseStartDate, totalDta, onChangeUserhandle, setAlumni, setMembership, setVerifiedData,setSortVal,sortVal, SetExpiresOn, expiresOn }) => {

    const dispatch = useDispatch();

    const [pageData, setPageData] = useState({ currentPage: 1, perPage: postTable ? 1 : 10, totalData: null, totalPage: 5, maxLength: 10 });
    const [dataSource, setDataSource] = useState([]);
    const [tempTableData, setTempTableData] = useState([]);
    const [filterData, setFilterData] = useState({ filter: false, type: '' });
    const [alumniFilter, setalumniFilter] = useState([]);
    const [verifiedEmailFilter, setVerifiedEmailFilter] = useState([]);
    const [createdByFilter, setcreatedByFilter] = useState([]);
    const [projectWiseFilter, setProjectWiseFilter] = useState([]);
    const [membershipFilter, setmembershipFilter] = useState([]);
    const [typeFilter, settypeFilter] = useState([]);
    const [courseFilter, setcourseFilter] = useState([]);
    const [skillFilter, setskillFilter] = useState([]);
    const [ownerFilter, setOwnerFilter] = useState([]);
    const [tagFilter, settagFilter] = useState([]);
    const [select, setSelect] = useState(null);
    const [selectedPage , setSelectPage] = useState({ currentPage: 1, perPage: postTable ? 1 : 10, totalData: null, totalPage: 5, maxLength: 10 })
    const [sort, setSort] = useState({
        purchasedOn: false,
        expiresOn: false,
        lastLoggedOn: false,
        addedOn: false,
    });
    const { contextReducer } = useContext(ContextState);
    const location = useLocation();
    const { pathname  } = location;


    useEffect(() => {
        setFilterData({ filter: false, type: '' });
        setalumniFilter([]);
        setVerifiedEmailFilter([]);
        setcreatedByFilter([]);
        setProjectWiseFilter([]);
        setmembershipFilter([]);
        settypeFilter([]);
        setOwnerFilter([]);
        setcourseFilter([]);
        setDataSource([]);
        setPageData({ currentPage: 1, perPage: postTable ? 1 : 10, totalData: null, totalPage: 5, maxLength: 10 });
        setSelectPage({currentPage: 1, perPage: postTable ? 1 : 10, totalData: null, totalPage: 5, maxLength: 10})
        setSort({
            purchasedOn: false,
            expiresOn: false,
            lastLoggedOn: false,
            addedOn: false,
        });
    }, [contextReducer.cms_type]);

    useEffect(() => {
        setTempTableData(tableData)
    }, [tableData]);

    useEffect(()=>{
        setSelectPage({...selectedPage, currentPage: 1})
    },[search?.title])

    /**--------------------------------- Filter section ------------------------------*/
    useEffect(() => {
        if (loading) {
            return false;
        }
     
        if (!membershipFilter.length && !verifiedEmailFilter.length && !alumniFilter.length && !skillFilter.length && !ownerFilter.length && !tagFilter.length && !typeFilter.length && !courseFilter.length && !createdByFilter.length && !projectWiseFilter.length) {
            setTempTableData(filteredPosts?.length ? filteredPosts : tableData || []);
        }
    }, [membershipFilter, alumniFilter, skillFilter, ownerFilter, tagFilter, typeFilter, courseFilter, createdByFilter, projectWiseFilter, filteredPosts, loading, tableData, verifiedEmailFilter]);

    useEffect(() => {
        if (membershipFilter.length !== 0 || alumniFilter.length !== 0 || verifiedEmailFilter.length !== 0 || projectWiseFilter.length !== 0) {
            const forFilter = filteredPosts?.length ? filteredPosts : tableData || [];
            let data = forFilter.filter((mv) => {
                return alumniFilter.some((category) => [mv.userdetails?.is_usc_alum?.toLowerCase()].includes(category)) ||
                    membershipFilter.some((category) => [mv.memberdetails?.membership_type].includes(category)) ||
                    projectWiseFilter.some((category) => [mv?.course_type].includes(category)) ||
                    verifiedEmailFilter.some((category) => (mv?.is_verified && category === "verified") || (!mv?.is_verified && category === "not_verified"));
            })
            console.log("tableData3")
            setTempTableData(contextReducer.cms_type === 'skill-up' && pathname === "/users" ? tableData : data);
        }
    }, [membershipFilter, alumniFilter, filteredPosts, verifiedEmailFilter, loading, tableData, projectWiseFilter]);

    useEffect(() => {
        if (skillFilter.length !== 0 || typeFilter.length !== 0 || courseFilter.length !== 0) {
            const forFilter = filteredPosts?.length ? filteredPosts : tableData || []
            if (forFilter[0] !== '') {
                console.log("tableData4")
                setTempTableData(
                    forFilter.filter((mv) => {
                        if (!typeFilter.length && !courseFilter.length)
                            return skillFilter.some((category) => mv.category_id.includes(category));
                        else if (!skillFilter.length && !courseFilter.length)
                            return typeFilter.some((category) => [mv.type?.toLowerCase()].includes(category));
                        else if (!skillFilter.length && !typeFilter.length)
                            return courseFilter.some((category) => [mv.course].includes(category));
                        else if (!skillFilter.length)
                            return typeFilter.some((category) => [mv.type?.toLowerCase()].includes(category)) && courseFilter.some((category) => [mv.course].includes(category));
                        else if (!typeFilter.length)
                            return skillFilter.some((category) => mv.category_id.includes(category)) && courseFilter.some((category) => [mv.course].includes(category));
                        else if (!courseFilter.length)
                            return typeFilter.some((category) => [mv.type?.toLowerCase()].includes(category)) && skillFilter.some((category) => mv.category_id.includes(category));
                        else
                            return skillFilter.some((category) => mv.category_id.includes(category)) && typeFilter.some((category) => [mv.type?.toLowerCase()].includes(category)) && courseFilter.some((category) => [mv.course].includes(category));
                    })
                );
            }
        }
    }, [typeFilter, skillFilter, courseFilter, tableData, filteredPosts]);

    useEffect(() => {
        if (createdByFilter.length !== 0) {
            const forFilter = filteredPosts?.length ? filteredPosts : tableData || []
           
            setTempTableData(
                forFilter.filter((mv) => {
                    return createdByFilter.some((category) => [mv.created_by].includes(category));
                })
            );
        }
    }, [createdByFilter, filteredPosts, tableData]);

    useEffect(() => {
        if (ownerFilter.length !== 0) {
            const forFilter = filteredPosts?.length ? filteredPosts : tableData || []
            console.log("tableData6")
            setTempTableData(
                forFilter.filter((mv) => {
                    return ownerFilter.some((category) => {
                        switch (category) {
                            case "User":
                                return !([mv.Owner].includes("Admin") || [mv.Owner].includes("Community Manager"))

                            default:
                                return [mv.Owner].includes(category)
                        }
                    }
                    );
                })
            );
        }
    }, [ownerFilter, filteredPosts, tableData]);

    useEffect(() => {
        if (skillFilter.length !== 0 || tagFilter.length !== 0) {
            const forFilter = filteredPosts?.length ? filteredPosts : tableData || []
            if (forFilter[0] != '') {
                console.log("tableData7")
                setTempTableData(
                    forFilter.filter((mv) => {
                        if (!tagFilter.length)
                            return skillFilter.some((category) => mv.category_id.includes(category));
                        else if (!skillFilter.length)
                            return tagFilter.some((category) => mv.tags.includes(category));
                        else
                            return skillFilter.some((category) => mv.category_id.includes(category)) && tagFilter.some((category) => mv.tags.includes(category));
                    })
                );
            }
        }
    }, [skillFilter, tagFilter, filteredPosts, tableData]);

    /**--------------------------------- Filter section ------------------------------*/

    useEffect(() => {
        if (dataSource?.length > 0) {
            if (tempTableData.length === 0) {
                setDataSource([]);
            }
        }
    }, [dataSource?.length, tempTableData?.length, loading]);

    useEffect(() => {
        if (popContent && !postTable) {
            setDataSource(tempTableData);
        }
    }, [tempTableData]);

    useEffect(() => {

        setPageData({ ...pageData, currentPage: 1 })
        setSelectPage({...selectedPage, currentPage: 1})
    }, [tabName]);


    const renderReplacer = (num) => {
        if (select) {
            if (num === select) {
                return <button className="btn-cancel" onClick={() => setSelect(null)} >cancel</button>
            } else {
                return <button className="btn-yellow" onClick={() => updateSelection(num)} >replace</button>
            }
        } else {
            return <button className="btn-replace" onClick={() => setSelect(num)} >select</button>
        }
    }

    const updateSelection = (num) => {
        dragUpdater(num, select);
        setSelect(null);
    }


    const renderContent = () => {
        return (
            loading ?
                [0, 1, 2, 3, 4].map(_ =>
                (<tr>
                    {columns.map(col => {
                        switch (col.type) {
                            case "custom": {
                                return <td><Skeleton /></td>
                            }
                            case "action": {
                                return <td><Skeleton /></td>
                            }
                            case "firstCol": {
                                if (col.dataIndex === "indicator") {
                                    return (
                                        <td className="text_right"><Skeleton /></td>
                                    )
                                } else if (col.dataIndex === "isVerified") {
                                    return (
                                        <td className="text_center"><Skeleton /></td>
                                    )
                                }
                                break;
                            }
                            default: {
                                return <td className={`${col.dataIndex !== 'email' ? 'capitalize' : ''}`}><Skeleton /></td>
                            }

                        }
                    })}
                </tr>)
                )
                :
                !tempTableData?.length ? <tr><div className="no-data" >No Data Found</div></tr>
                    : dataSource?.map((data, index) => (
                        <tr>
                            {data === '' || data === undefined ? <div className="no-data">No Data Found</div>
                                : columns.map(col => {
                                    switch (col.type) {
                                        case "custom": {
                                            return col?.render(data)
                                        }
                                        case "action": {
                                            return col?.ActionContent(data)
                                        }
                                        case "firstCol": {
                                            if (col.dataIndex === "order_num") {
                                                return <td>
                                                    {
                                                        renderReplacer(data.order_num)
                                                    }
                                                </td>
                                            }
                                            if (col?.dataIndex === "indicator") {
                                                return (
                                                    data?.date || data?.start_time
                                                        ? <td className="text_right"><span className={`dot_${col?.getColor(data)}`}></span></td>
                                                        : <td className="text_center" />
                                                )
                                            } else if (col.dataIndex === "isVerified") {
                                                if (contextReducer.cms_type !== 'skill-up') {
                                                    return ((Object.keys(data).includes('is_verified') && !data.is_verified) || (Object.keys(data).includes('mail_activate') && !data.mail_activate) ?
                                                        <td className="text_center">
                                                            <Tooltip
                                                                overlayClassName="custom-tooltip"
                                                                placement="bottom"
                                                                align={{
                                                                    points: ['tc', 'bc'],
                                                                    offset: [0, 0],
                                                                    targetOffset: ['0%', '0%'],
                                                                    overflow: { adjustX: true, adjustY: true }
                                                                }}
                                                                title={`${!data.is_register ? 'Registration Pending' : 'Confirmation Pending'}`}
                                                            >
                                                                <span><img src={icon_alert} alt="Alert icon" height="13" /></span>
                                                            </Tooltip>
                                                        </td> :
                                                        <td className="text_center" />
                                                    )
                                                } else {
                                                    return ((Object.keys(data).includes('is_verified') && !data.is_verified) || (Object.keys(data).includes('mail_activate') && !data.mail_activate) ?
                                                        <td className="text_center"><span><img src={icon_alert} alt="Alert icon" height="13" /></span></td> :
                                                        <td className="text_center" />
                                                    )
                                                }
                                            }
                                            break;
                                        }
                                        default: {
                                            return <td className={`${col?.dataIndex !== 'email' ? 'capitalize' : ''}`}>{data[col.dataIndex] && String(data[col.dataIndex])?.toLowerCase()}</td>
                                        }

                                    }
                                })
                            }
                        </tr>
                    ))
        )
    };

    const onFilterClick = (title) => {
        if (title === 'Alumni')
            setFilterData({ type: 'Alumni', filter: !filterData.filter })
        else if (title === 'Membership')
            setFilterData({ type: 'Membership', filter: !filterData.filter })
        else if (title === 'Type')
            setFilterData({ type: 'Type', filter: !filterData.filter })
        else if (title === 'Course')
            setFilterData({ type: 'Course', filter: !filterData.filter })
    }

    const onSort = (title, index) => {
        const sortData = [...tempTableData];
        if (title === 'Added On') {
            if((contextReducer.cms_type === 'skill-up' || contextReducer.cms_type === 'pre-college' || contextReducer.cms_type  === 'certificates' ||  contextReducer.cms_type  === 'dl-program')  && (pathname === "/users" || pathname === "/applicants")){
                setSelectPage({...selectedPage, currentPage: 1}) 
                setSortVal({
                    sortType:!sort[index]?"desc":"asc",
                    sortOn:"created_at"
                })
                // setSortType(sortOn.includes("created_at")?"desc":"asc")
                // let newSortOnVal= sortOn.includes("created_at") ? sortOn.filter((x)=>x!=="created_at"):[...sortOn,"created_at"]
                // setSortOn(newSortOnVal)
            }
            
            sortData.sort(function (left, right) {
                if (!sort[index])
                    return moment.utc(right.created_at).diff(moment.utc(left.created_at))
                else
                    return moment.utc(left.created_at).diff(moment.utc(right.created_at))
            });
        }
        else if (title === 'Last Logged On') {
            if((contextReducer.cms_type === 'skill-up' || contextReducer.cms_type === 'pre-college' || contextReducer.cms_type  === 'certificates' || contextReducer.cms_type  === 'dl-program')  && (pathname === "/users" || pathname === "/applicants")){
                setSelectPage({...selectedPage, currentPage: 1}) 
                setSortVal({
                    sortType:!sort[index]?"desc":"asc",
                    sortOn:"last_login"
                })
            }
            
            sortData.sort(function (left, right) {
                if (!sort[index])
                    return moment.utc(right.last_login).diff(moment.utc(left.last_login))
                else
                    return moment.utc(left.last_login).diff(moment.utc(right.last_login))
            });
        }
        else if (title === 'Expires On') {
            if((contextReducer.cms_type === 'skill-up' || contextReducer.cms_type  === 'certificates') && pathname === "/users"){
                setSelectPage({...selectedPage, currentPage: 1})  
                setSortVal({
                    sortType:!sort[index]?"desc":"asc",
                    sortOn:"expires_on"
                })
            }
           
            sortData.sort(function (left, right) {
                if (!sort[index])
                    return moment.utc(moment(right.paymentdetails?.next_payment_date)).diff(moment.utc(moment(left.paymentdetails?.next_payment_date)))
                else
                    return moment.utc(moment(left.paymentdetails?.next_payment_date)).diff(moment.utc(moment(right.paymentdetails?.next_payment_date)))
            });
        }
        else if (title === 'Purchased On') {
            if((contextReducer.cms_type === 'skill-up' || contextReducer.cms_type  === 'certificates') && pathname === "/users"){
                setSelectPage({...selectedPage, currentPage: 1})  
                setSortVal({
                    sortType:!sort[index]?"desc":"asc",
                    sortOn:"purchased_on"
                })
            }  
            
            // SetPurchasedOn({...purchasedOn,purchase_on:!purchasedOn.purchase_on})
            sortData.sort(function (left, right) {
                if (!sort[index])
                    return moment.utc(right.paymentdetails?.created_at).diff(moment.utc(left.paymentdetails?.created_at))
                else
                    return moment.utc(left.paymentdetails?.created_at).diff(moment.utc(right.paymentdetails?.created_at))
            });
        }
        else if (title === 'Post Date') {
            sortData.sort(function (left, right) {
                if (!sort[index])
                    return moment.utc(right?.updated_at).diff(moment.utc(left?.updated_at))
                else
                    return moment.utc(left?.updated_at).diff(moment.utc(right?.updated_at))
            });
        }
        else if (title === 'Course Start Date') {
            console.log("index==========", sort[index])
            let setpanding =  contextReducer.cms_type === 'certificates'  ? certsalesPaymentPending : salesPaymentPending
            setpanding({
                course_id: courseKey,
                course_start_date: courseStartDate,
                sorting: sort[index] === undefined ? "ASC" : sort[index] === true ? "DESC" : "ASC"
            }).then((res) => {
                // setLoading(false)
                if (res.status === 200) {
                    dispatch(salesPaymentPendingData(res.data.data))
                    setDataSet(res.data.data)
                }
            })
            sortData.sort(function (left, right) {
                if (!sort[index])
                    return moment.utc(right.course_start_date).diff(moment.utc(left.course_start_date))
                else
                    return moment.utc(left.course_start_date).diff(moment.utc(right.course_start_date))
            });
        }
        setSort({ ...sort, [index]: !sort[index] })
        console.log("tableData8")
        setTempTableData(sortData);
    };

    const onCheckboxChange = (e) => {
        if (e.target.name === 'verifiedEmail') {
            if (e.target.checked) {
                setSelectPage({...selectedPage,currentPage: 1})
                let newarray = [...verifiedEmailFilter]
                newarray.push(e.target.id)
                setVerifiedEmailFilter(newarray)
                const Data = e.target.id === 'not_verified' ?  'false' : 'true'
                setVerifiedData(Data)
            } else {
                setVerifiedData(null)
                setVerifiedEmailFilter(verifiedEmailFilter.filter((id) => id !== e.target.id))
            }
        } else if (e.target.name === 'alumni') {
            if (e.target.checked) {
                setSelectPage({...selectedPage,currentPage: 1})
                let newarray = [...alumniFilter]
                newarray.push(e.target.id)
                setalumniFilter(newarray)
                if(contextReducer.cms_type === 'skill-up'){
                    setAlumni(e.target.id)
                }
            }
            else {
                setAlumni(null)
                setalumniFilter(alumniFilter.filter((id) => id !== e.target.id))
            }
        }
        else if (e.target.name === 'membership') {
            if (e.target.checked) {
                setSelectPage({...selectedPage,currentPage: 1})
                let newarray = [...membershipFilter]
                newarray.push(e.target.id)
                setmembershipFilter(newarray);
                if(contextReducer.cms_type === 'skill-up'){
                    setMembership(e.target.id)
                }
            }
            else {
                setMembership(null)
                setmembershipFilter(membershipFilter.filter((id) => id !== e.target.id));
            }
        }
        else if (e.target.name === 'type') {
            if (e.target.checked) {
                let newarray = [...typeFilter]
                newarray.push(e.target.id)
                settypeFilter(newarray);
            }
            else {
                settypeFilter(typeFilter.filter((id) => id !== e.target.id));
            }
        }
        else if (e.target.name === 'course') {
            if (e.target.checked) {
                let newarray = [...courseFilter]
                newarray.push(e.target.id)
                setcourseFilter(newarray);
            }
            else {
                setcourseFilter(courseFilter.filter((id) => id !== e.target.id));
            }
        }
        else if (e.target.name === 'created_by') {
            if (e.target.checked) {
                let newarray = [...createdByFilter]
                newarray.push(e.target.id)
                setcreatedByFilter(newarray);
            }
            else {
                setcreatedByFilter(createdByFilter.filter((id) => id !== e.target.id));
            }
        }
        else if (e.target.name === 'course_type') {
            if (e.target.checked) {
                let newarray = [...projectWiseFilter]
                newarray.push(e.target.id)
                setProjectWiseFilter(newarray);
            }
            else {
                setProjectWiseFilter(projectWiseFilter.filter((id) => id !== e.target.id));
            }
        }
        else if (e.target.name === 'owner') {
            if (e.target.checked) {
                let newarray = [...ownerFilter]
                newarray.push(e.target.id)
                setOwnerFilter(newarray);
            }
            else {
                setOwnerFilter(ownerFilter.filter((id) => id !== e.target.id));
            }
        }
        else if (e.target.name === 'all_skill') {
            if (e.target.checked) {
                let newarray = category.map(cat => cat.id);
                setskillFilter(newarray);
            }
            else {
                setskillFilter([]);
            }
        }
        else if (e.target.name === 'skill') {
            if (e.target.checked) {
                let newarray = [...skillFilter]
                newarray.push(e.target.id)
                setskillFilter(newarray);
            }
            else {
                setskillFilter(skillFilter.filter((id) => id !== e.target.id));
            }
        }
        else if (e.target.name === 'all_tags') {
            if (e.target.checked) {
                let newarray = tag.map(_ => _.name);
                settagFilter(newarray);
            }
            else {
                settagFilter([]);
            }
        }
        else if (e.target.name === 'tags') {
            if (e.target.checked) {
                let newarray = [...tagFilter]
                newarray.push(e.target.id)
                settagFilter(newarray);
            }
            else {
                settagFilter(tagFilter.filter((id) => id !== e.target.id));
            }
        }
    }

    const handlePage = (number) => {
      
        if((contextReducer.cms_type === 'skill-up' || contextReducer.cms_type === 'pre-college' || contextReducer.cms_type  === 'certificates' || contextReducer.cms_type  === 'dl-program') && (pathname === "/users" || pathname === "/applicants")){
            onChangeUserhandle(number)
            setSelectPage({...selectedPage, currentPage: number})    
            // setPageData({ ...pageData, currentPage: number })
        }else{
            if (number < 1 || number > pageData.totalPage) {
                return false;
            } else { 
                    const indexOfLastPage = number * pageData.perPage;
                
                    const indexOfFirstPage = indexOfLastPage - pageData.perPage;
                    const currentData = tempTableData.slice(indexOfFirstPage, indexOfLastPage);
                    setDataSource(currentData);
                    setPageData({ ...pageData, currentPage: number })
               
                
            } 
        }
        if(contextReducer.cms_type !== 'skill-up' && contextReducer.cms_type !== 'pre-college' && contextReducer.cms_type  !== 'certificates' && contextReducer.cms_type  !== 'dl-program'){
            if (number < 1 || number > pageData.totalPage) {
                return false;
            } else { 
                    const indexOfLastPage = number * pageData.perPage;
                
                    const indexOfFirstPage = indexOfLastPage - pageData.perPage;
                    const currentData = tempTableData.slice(indexOfFirstPage, indexOfLastPage);
                    setDataSource(currentData);
                    console.log("currentPage4",number);
                    setPageData({ ...pageData, currentPage: number })
               
                
            }
        }
       
    };


    const showPagination_number = () => {
        if ((pathname === "/users" || pathname === "/applicants") && contextReducer.cms_type !== "career-launch") {
            return totalDta;
        } else if (pathname === "/program" || pathname === "/event") {
            return !loading;
        } else {
            return true;
        }
    };

    return (
        <div className="table_wrapper">
            <div className="table_responsive vert_scroll">
                <SkeletonTheme
                    baseColor="#ebebeb"
                    highlightColor="#f5f5f5"
                    borderRadius="0.5rem"
                    duration={4}
                >
                    <table style={tempTableData?.length <= 0 ? { tableLayout: "auto" } : {}} className={`table ${className}`}>
                        <thead>
                            <tr>
                                {
                                    columns.map((col, index) => {
                                        if (col.title === 'Action') {
                                            return col.ActionHeader();
                                        } else {
                                            return <td key={index}>
                                                <p>
                                                    {col.title}
                                                    {col.filter && <span className={`filter_dropdown ${col.title === 'Alumni' ? 'alumni' : 'membership'} ${(col.title === 'Alumni' && alumniFilter.length) || (col.title === 'Membership' && membershipFilter.length) || (col.title === 'Course Type' && projectWiseFilter.length) || (col.title === 'Type' && typeFilter.length) || (col.title === 'Course' && courseFilter.length) || (col.title === 'Created By' && createdByFilter.length) || (col.title === 'Owner' && ownerFilter.length) || (col.title === 'Skill' && skillFilter.length) || (col.title === 'Tags' && tagFilter.length) ? 'filter icon_filter' : ''}`}><img src={icon_filter} alt="Filter" onClick={() => onFilterClick(col.title)} /></span>}
                                                    {col.sort && <img src={icon_order_arrow_down} onClick={() => onSort(col.title, col.dataIndex)} alt="Arrow" className={`${sort[col.dataIndex] ? 'arrow_down' : 'arrow_up'}`} />}
                                                    {
                                                        col.title === 'Email' &&
                                                        <div className="dropdown-menu">
                                                            <ul className="list_unstyled">
                                                                <li>
                                                                    <div className="checkbox_btn">
                                                                        <input name="verifiedEmail" type="checkbox" id='verified' checked={verifiedEmailFilter.includes('verified')} onChange={onCheckboxChange} />
                                                                        <span></span>
                                                                    </div>
                                                                    <label htmlFor="cohort_checkbox" className='d_flex white_space_nowrap pl_3'>Verified</label>
                                                                </li>
                                                                <li>
                                                                    <div className="checkbox_btn">
                                                                        <input name="verifiedEmail" type="checkbox" id='not_verified' checked={verifiedEmailFilter.includes('not_verified')} onChange={onCheckboxChange} />
                                                                        <span></span>
                                                                    </div>
                                                                    <label htmlFor="cohort_checkbox2" className='d_flex white_space_nowrap pl_3'>Not verified</label>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    }
                                                    {
                                                        col.title === 'Alumni' &&
                                                        <div className="dropdown-menu">
                                                            <ul className="list_unstyled">
                                                                <li>
                                                                    <div className="checkbox_btn">
                                                                        <input name="alumni" type="checkbox" id='no' checked={alumniFilter.includes('no')} onChange={onCheckboxChange} />
                                                                        <span></span>
                                                                    </div>
                                                                    <label htmlFor="cohort_checkbox" className='d_flex white_space_nowrap pl_3'>No</label>
                                                                </li>
                                                                <li>
                                                                    <div className="checkbox_btn">
                                                                        <input name="alumni" type="checkbox" id='yes' checked={alumniFilter.includes('yes')} onChange={onCheckboxChange} />
                                                                        <span></span>
                                                                    </div>
                                                                    <label htmlFor="cohort_checkbox2" className='d_flex white_space_nowrap pl_3'>Yes</label>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    }

                                                    {
                                                        col.title === 'Membership' &&
                                                        <div className="dropdown-menu">
                                                            <ul className="list_unstyled">
                                                                <li>
                                                                    <div className="checkbox_btn">
                                                                        <input name="membership" type="checkbox" id='Limited' checked={membershipFilter.includes('Limited')} onChange={onCheckboxChange} />
                                                                        <span></span>
                                                                    </div>
                                                                    <label htmlFor="cohort_checkbox" className='d_flex white_space_nowrap pl_3'>Limited</label>
                                                                </li>
                                                                <li>
                                                                    <div className="checkbox_btn">
                                                                        <input name="membership" type="checkbox" id='Accelerate Your Career' checked={membershipFilter.includes('Accelerate Your Career')} onChange={onCheckboxChange} />
                                                                        <span></span>
                                                                    </div>
                                                                    <label htmlFor="cohort_checkbox2" className='d_flex white_space_nowrap pl_3'>Accelerate Your Career</label>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    }
                                                    {
                                                        col.title === 'Type' &&
                                                        <div className="dropdown-menu">
                                                            <ul className="list_unstyled">
                                                                <li>
                                                                    <div className="checkbox_btn">
                                                                        <input name="type" type="checkbox" id='closed' checked={typeFilter.includes('closed')} onChange={onCheckboxChange} />
                                                                        <span></span>
                                                                    </div>
                                                                    <label htmlFor="cohort_checkbox" className='d_flex white_space_nowrap pl_3'>Closed</label>
                                                                </li>
                                                                <li>
                                                                    <div className="checkbox_btn">
                                                                        <input name="type" type="checkbox" id='open' checked={typeFilter.includes('open')} onChange={onCheckboxChange} />
                                                                        <span></span>
                                                                    </div>
                                                                    <label htmlFor="cohort_checkbox2" className='d_flex white_space_nowrap pl_3'>Open</label>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    }
                                                    {
                                                        col.title === 'Owner' &&
                                                        <div className="dropdown-menu">
                                                            <ul className="list_unstyled">
                                                                <li>
                                                                    <div className="checkbox_btn">
                                                                        <input name="owner" type="checkbox" id='Admin' checked={ownerFilter.includes('Admin')} onChange={onCheckboxChange} />
                                                                        <span></span>
                                                                    </div>
                                                                    <label htmlFor="cohort_checkbox" className='d_flex white_space_nowrap pl_3'>Admin</label>
                                                                </li>
                                                                <li>
                                                                    <div className="checkbox_btn">
                                                                        <input name="owner" type="checkbox" id='Community Manager' checked={ownerFilter.includes('Community Manager')} onChange={onCheckboxChange} />
                                                                        <span></span>
                                                                    </div>
                                                                    <label htmlFor="cohort_checkbox" className='d_flex white_space_nowrap pl_3'>Community manager</label>
                                                                </li>
                                                                <li>
                                                                    <div className="checkbox_btn">
                                                                        <input name="owner" type="checkbox" id='User' checked={ownerFilter.includes('User')} onChange={onCheckboxChange} />
                                                                        <span></span>
                                                                    </div>
                                                                    <label htmlFor="cohort_checkbox2" className='d_flex white_space_nowrap pl_3'>User</label>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    }
                                                    {
                                                        col.title === 'Course' &&
                                                        <div className="dropdown-menu">
                                                            <ul className="list_unstyled">
                                                                <li>
                                                                    <div className="checkbox_btn">
                                                                        <input name="course" type="checkbox" id='Yes' checked={courseFilter.includes('Yes')} onChange={onCheckboxChange} />
                                                                        <span></span>
                                                                    </div>
                                                                    <label htmlFor="cohort_checkbox" className='d_flex white_space_nowrap pl_3'>Yes</label>
                                                                </li>
                                                                <li>
                                                                    <div className="checkbox_btn">
                                                                        <input name="course" type="checkbox" id='No' checked={courseFilter.includes('No')} onChange={onCheckboxChange} />
                                                                        <span></span>
                                                                    </div>
                                                                    <label htmlFor="cohort_checkbox2" className='d_flex white_space_nowrap pl_3'>No</label>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    }
                                                    {
                                                        col.title === 'Created By' &&
                                                        <div className="dropdown-menu">
                                                            <ul className="list_unstyled">
                                                                <li>
                                                                    <div className="checkbox_btn">
                                                                        <input name="created_by" type="checkbox" id='Admin' checked={createdByFilter.includes('Admin')} onChange={onCheckboxChange} />
                                                                        <span></span>
                                                                    </div>
                                                                    <label htmlFor="cohort_checkbox" className='d_flex white_space_nowrap pl_3'>Admin</label>
                                                                </li>
                                                                <li>
                                                                    <div className="checkbox_btn">
                                                                        <input name="created_by" type="checkbox" id='Community Manager' checked={createdByFilter.includes('Community Manager')} onChange={onCheckboxChange} />
                                                                        <span></span>
                                                                    </div>
                                                                    <label htmlFor="cohort_checkbox2" className='d_flex white_space_nowrap pl_3'>Community Manager</label>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    }
                                                    {
                                                        col.title === 'Course Type' &&
                                                        <div className="dropdown-menu">
                                                            <ul className="list_unstyled">
                                                                <li>
                                                                    <div className="checkbox_btn">
                                                                        <input name="course_type" type="checkbox" id='Skill up' checked={projectWiseFilter.includes('Skill up')} onChange={onCheckboxChange} />
                                                                        <span></span>
                                                                    </div>
                                                                    <label htmlFor="cohort_checkbox" className='d_flex white_space_nowrap pl_3'>Skill up</label>
                                                                </li>
                                                                <li>
                                                                    <div className="checkbox_btn">
                                                                        <input name="course_type" type="checkbox" id='Career Launchpad' checked={projectWiseFilter.includes('Career Launchpad')} onChange={onCheckboxChange} />
                                                                        <span></span>
                                                                    </div>
                                                                    <label htmlFor="cohort_checkbox2" className='d_flex white_space_nowrap pl_3'>Career Launchpad</label>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    }
                                                    {
                                                        col.title === 'Skill' &&
                                                        <div className="dropdown-menu">
                                                            <ul className="list_unstyled">
                                                                <li>
                                                                    <div className="checkbox_btn">
                                                                        <input name="all_skill" type="checkbox" checked={skillFilter.length === category?.length} onChange={onCheckboxChange} />
                                                                        <span></span>
                                                                    </div>
                                                                    <label htmlFor="cohort_checkbox2" className='d_flex white_space_nowrap pl_3'>All</label>
                                                                </li>
                                                                {category?.map(_ =>
                                                                    <li>
                                                                        <div className="checkbox_btn">
                                                                            <input name="skill" type="checkbox" id={_.id} checked={skillFilter.includes(_.id)} onChange={onCheckboxChange} />
                                                                            <span></span>
                                                                        </div>
                                                                        <label htmlFor="cohort_checkbox2" className='d_flex white_space_nowrap pl_3'>{_.name}</label>
                                                                    </li>
                                                                )}
                                                            </ul>
                                                        </div>
                                                    }
                                                    {
                                                        col.title === 'Tags' &&
                                                        <div className="dropdown-menu">
                                                            <ul className="list_unstyled">
                                                                <li>
                                                                    <div className="checkbox_btn">
                                                                        <input name="all_tags" type="checkbox" checked={tagFilter.length === tag?.length} onChange={onCheckboxChange} />
                                                                        <span></span>
                                                                    </div>
                                                                    <label htmlFor="cohort_checkbox2" className='d_flex white_space_nowrap pl_3'>All</label>
                                                                </li>
                                                                {tag?.map(_ =>
                                                                    <li>
                                                                        <div className="checkbox_btn">
                                                                            <input name="tags" type="checkbox" id={_.name} checked={tagFilter.includes(_.name)} onChange={onCheckboxChange} />
                                                                            <span></span>
                                                                        </div>
                                                                        <label htmlFor="cohort_checkbox2" className='d_flex white_space_nowrap pl_3'>{_.name}</label>
                                                                    </li>
                                                                )}
                                                            </ul>
                                                        </div>
                                                    }
                                                </p>
                                            </td>
                                        }
                                    })
                                }
                            </tr>
                        </thead>
                        <tbody className="drag-container">
                            {
                                renderContent()
                            }
                        </tbody>
                    </table>
                    {tempTableData && pageData.perPage < tempTableData?.length && postTable && <div className="post_table">
                        <span onClick={() => { handlePage(pageData.currentPage - 1) }} className={pageData.currentPage !== 1 ? "arrow_previous" : "arrow_previous disabled"}><img src={icon_arrow_left} alt="Arrow previous" height="16" /></span>
                        <span onClick={() => { handlePage(pageData.currentPage + 1) }} className={(pageData.currentPage < pageData.totalPage.length) ? "arrow_next" : "arrow_next disabled"}><img src={icon_arrow_left} alt="Arrow next" height="16" /></span>
                    </div>}
                </SkeletonTheme>
            </div>
            {((!popContent || postTable || totalDta) && (search?.title ? !loading : true) && showPagination_number()) ? <Pagination
                search={search}
                flag={flag}
                setFlag={setFlag}
                dataSource={tempTableData}
                filteredPosts={filteredPosts}
                setDataSource={setDataSource}
                pageData={pageData}
                setPageData={setPageData}
                handlePage={handlePage}
                totalDta={totalDta}
                selectedPage={selectedPage}
            />
                : ''}

                
        </div>
    )
};

export default CustomTable